export const normalizeProductForCart = (product: any, overrides: any = {}) => {
  const sellerUserId = String(
    product?.userId ||
      product?.sellerUserId ||
      product?.ownerId ||
      product?.sellerId ||
      "",
  ).trim();

  const productId = String(
    overrides._id ||
      overrides.id ||
      overrides.productId ||
      product?._id ||
      product?.id ||
      product?.productId ||
      "",
  ).trim();

  const selectedImage =
    overrides.imageUrl ||
    overrides.image ||
    overrides.selectedImage ||
    product.selectedImage ||
    product.resolvedImage ||
    product.imageUrl ||
    product.image ||
    product.thumbnail ||
    (Array.isArray(product.images) ? product.images[0] : "") ||
    "";

  const selectedPrice = Number(
    overrides.selectedPrice ??
      overrides.price ??
      product.selectedPrice ??
      product.price ??
      0,
  );

  return {
    ...product,
    ...overrides,

    id: productId,
    _id: productId,
    productId,

    /**
     * In this app, product.userId is the seller id.
     * sellerUserId and ownerId are compatibility aliases for checkout/order logic.
     */
    userId: String(product?.userId || sellerUserId).trim(),
    sellerUserId,
    ownerId: String(
      product?.ownerId || product?.sellerUserId || sellerUserId,
    ).trim(),

    sellerBusinessName:
      product?.sellerBusinessName ||
      product?.businessName ||
      product?.sellerName ||
      product?.shopName ||
      "",

    dispatchWarehouseId: product?.dispatchWarehouseId || "",

    title: overrides.title || product.title || "Untitled product",
    description: overrides.description ?? product.description ?? "",
    category: overrides.category ?? product.category ?? "Car Parts",

    image: selectedImage,
    imageUrl: selectedImage,
    selectedImage,

    images: Array.isArray(product.images) ? product.images : [],

    price: selectedPrice,
    selectedPrice,

    quantity: Math.max(1, Number(overrides.quantity || product.quantity || 1)),

    selectedVariants: Array.isArray(overrides.selectedVariants)
      ? overrides.selectedVariants
      : Array.isArray(product.selectedVariants)
        ? product.selectedVariants
        : [],

    variantSummary: overrides.variantSummary || product.variantSummary || "",

    isPhysical:
      typeof product.isPhysical === "boolean" ? product.isPhysical : true,

    weightKg: Number(product.weightKg || 0),
    lengthCm: Number(product.lengthCm || 0),
    widthCm: Number(product.widthCm || 0),
    heightCm: Number(product.heightCm || 0),
    bulky: Boolean(product.bulky),
  };
};
